<template>
    <div>
        <h1>Version courte ...</h1>
    </div>
</template>

<script>
    export default {
        name: "VersionCourte"
    }
</script>

<style scoped>

</style>